<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <!-- <div style="height: 60px"></div> -->
    <div style="width: 1rem; height: 1rem" v-if="!download"></div>
    <div class="title" v-if="!download">
      <img
        class="title-logo"
        @click="gotoHome()"
        src="@/../static/img/logo.png"
      />

      <i @click="showTitle = !showTitle" class="el-icon-s-fold title-icon"></i>

      <!-- <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item index="/"> 首页</el-menu-item>

        <el-menu-item index="/aboutUs">关于我们</el-menu-item>
        <el-menu-item index="/products">产品服务</el-menu-item>
        <el-menu-item index="/partner">合伙人招募</el-menu-item>
        <el-menu-item index="/jobs">加入我们</el-menu-item>
        <el-menu-item index="/news">新闻资讯</el-menu-item>
        <el-menu-item index="/contact">联系我们</el-menu-item>
      </el-menu> -->
      <div :class="showTitle == true ? 'open' : 'navbar'">
        <ul class="nav">
          <li>
            <a href="/" role="nav">首页</a>
          </li>
          <li>
            <a href="/aboutUs" role="nav">关于我们</a>
          </li>
          <li>
            <a href="/products" role="nav">产品服务</a>
          </li>
          <li>
            <a href="/partner" role="nav">合伙人招募</a>
          </li>
          <li>
            <a href="/jobs" role="nav">加入我们</a>
          </li>
          <li>
            <a href="/news" role="nav">新闻资讯</a>
          </li>
          <li>
            <a href="/contact" role="nav">联系我们</a>
          </li>
          <li>
            <a href="/download" role="nav">APP下载</a>
          </li>
        </ul>
      </div>
    </div>
    <div @touchstart="showTitle = false">
      <router-view />
    </div>
    <div style="position: relative" v-if="!download">
      <!-- <div class="footer">
        匡济医学科技（广东横琴）有限公司 Copyright © Kuang Ji Medical Technology
        (Guangdong Hengqin) Co., Ltd.
      </div> -->
      <div class="footer-click" @click="goGov"></div>
      <img style="width: 100%" src="@/../static/img/footer.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  beforeRouteEnter(to, from, next) {
    console.log("beforeRouteEnter");
  },
  computed: {
    activeIndex() {
      return this.$route.path;
    },
  },
  data() {
    return {
      showTitle: false,
      download: false,
    };
  },
  created() {
    if (this.$route.path.indexOf("download") > -1) {
      this.download = true;
    }
    if (this.$route.query.orgId&&this.$route.query.measureId) {
      this.$alert('请使用微信扫一扫，或扫描网页版二维码。', '提示', {
          confirmButtonText: '确定',
          type:'warning',
          callback: action => {
          }
        });
    }
  },
  methods: {
    goGov() {
      window.open("https://beian.miit.gov.cn/");
    },
    gotoHome() {
      this.$router.push({ path: "/" });
    },

    handleSelect(key) {
      this.$router.push({ path: key });
      console.log(key);
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  /* min-width: 1360px; */
}
</style>
<style lang='less' scoped>
.title {
  width: 7.5rem;
  // height: 100%;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #fff;
  background-color: #fff;
  position: fixed;
  top: 0;
  z-index: 200;
  padding: 0 0.28rem;
  box-shadow: 0 0 5px rgb(0 0 0 / 30%);
  .title-logo {
    width: 3.8rem;
    height: 0.8rem;
    // margin: auto 0.7rem auto;
  }
  .title-icon {
    font-size: 40px;
    margin-left: 20px;
    color: #196eee;
  }
}
.open {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: #fff;
  transform: translate(0, 1rem);
  margin: 0;
  transition: all 0.3s ease-in-out;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 20%);

  // transition: all 0.3s ease-in-out;
}
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: #fff;
  transform: translateY(-100%);
  margin: 0;
  transition: all 0.3s ease-in-out;
  // box-shadow: 0 4px 4px rgb(0 0 0 / 20%);
}
.nav li {
  text-align: left;
  padding: 0.24rem 0.4rem;
  line-height: normal;
  font-size: 0.28rem;
  border-bottom: 1px solid #ddd;
  a {
    display: block;
    width: 100%;
    color: #333;
  }
}
.el-menu.el-menu--horizontal {
  border: none;
}
.footer {
  width: 100%;
  text-align: center;
  // position: relative;
  position: absolute;
  bottom: 10px;
  left: 0;
  color: #fff;
  font-size: 12px;
}
.footer-click {
  font-size: 10px;
  width: 4rem;
  height: 20px;
  color: #fff;
  position: absolute;
  top: 1.9rem;
  left: 2.5rem;
  cursor: pointer;
  text-align: left;
  // background-color: red;
}
.el-menu-item {
  color: #303133;
}
.el-menu-item.is-active {
  border-bottom: 2px solid #409eff;
  color: black;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/App.vue